module.exports = __webpack_public_path__ + "img/logo-hib.03d75286.svg";